import { render, staticRenderFns } from "./tds.vue?vue&type=template&id=97ed4962&scoped=true"
import script from "./tds.vue?vue&type=script&lang=js"
export * from "./tds.vue?vue&type=script&lang=js"
import style0 from "./tds.vue?vue&type=style&index=0&id=97ed4962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ed4962",
  null
  
)

export default component.exports